import Button from 'components/base/Button';
import { Card, Col, Form, Row, Tab, Tabs, Toast, ToastContainer } from 'react-bootstrap';
import profileImage from 'assets/img/team/20.webp';
import { FormEvent, useEffect, useState } from 'react';
import { useMainLayoutContext } from 'providers/MainLayoutProvider';
import { useTranslation } from 'react-i18next';
import SettingsChangePassword from './componenets/SettingsChangePassword';
import apiClient, { handleAPIError } from 'helpers/apiService';
import { useAuth } from 'providers/AuthProvider'
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';



const Settings = () => {

  const { t } = useTranslation();
  const auth = useAuth();

  const [loading, setLoading] = useState(false);

  // State to control Toast messages
  const [show, setShow] = useState(false);
  const [toastMessage, setToastMessage] = useState('');


  const { setFooterClass } = useMainLayoutContext();


  useEffect(() => {
    setFooterClass('d-none d-lg-block');
    return () => {
      setFooterClass('');
    };

  }, []);


  const breadcrumbItems: PageBreadcrumbItem[] = [
    {
      label: t('Dashboard'),
      url: '/dashboard/home'
    },
    {
      label: t('Settings.page_title'),
      active: true
    }
  ];

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <PageBreadcrumb items={breadcrumbItems} />

      <ToastContainer className="p-3" position='top-center'>
        <Toast onClose={() => { setShow(false); }} show={show} delay={3000} autohide>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Card className='mt-3  mb-3 border border-light rounded-5 w-50' >
        <Card.Body>
          <h5 className="text-900 mb-3">{t("SettingsSideBar.see_your_profile")}</h5>
          <Form.Check type="radio" id="onlyMe">
            <Form.Check.Input
              type="radio"
              name="profiileVisibility"
              value="option1"
              defaultChecked
            />
            <Form.Check.Label htmlFor="onlyMe" className="fs-8">
              {t("SettingsSideBar.only_me")}
            </Form.Check.Label>
          </Form.Check>
          <Form.Check type="radio" id="myFollowers">
            <Form.Check.Input
              type="radio"
              name="profiileVisibility"
              value="option2"
            />
            <Form.Check.Label htmlFor="myFollowers" className="fs-8">
              {t("SettingsSideBar.my_contacts")}
            </Form.Check.Label>
          </Form.Check>
          <Form.Check type="radio" id="everyone">
            <Form.Check.Input
              type="radio"
              name="profiileVisibility"
              value="option3"
            />
            <Form.Check.Label htmlFor="everyone" className="fs-8">
              {t("SettingsSideBar.everyone")}
            </Form.Check.Label>
          </Form.Check>
        </Card.Body>
      </Card>



      <Card className='mt-3  mb-3 border border-light rounded-5 w-50' >
        <Card.Body>
          <SettingsChangePassword />
        </Card.Body>
      </Card>


    </>
  );
};

export default Settings;
